import React, { FunctionComponent, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Grid, Paper } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { WithBillPage } from "./WithBillPage";
import { WithOutBillPage } from "./WithOutBillPage";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    table: {
      minWidth: 650,
    },
  })
);
interface ItemReturntypes {
  customer_type: string;
  resetCustomer: () => void;
}
export const ItemReturn: FunctionComponent<ItemReturntypes> = ({
  customer_type,
  resetCustomer,
}) => {
  const classes = useStyles();
  const [withBill, setWithbill] = useState("true");
  const naviagateToItemReturn = (value: string) => {
    setWithbill(value);
  };
  return (
    <div className={classes.root}>
      <Paper elevation={2} className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <RadioGroup
              aria-label="position"
              row
              name="with_bill"
              onChange={(event: any) => {
                setWithbill(event.target.value);
              }}
              value={withBill}
            >
              <FormControlLabel
                value="true"
                control={<Radio color="primary" />}
                label="with Bill number"
                labelPlacement="end"
              />
              {/* <FormControlLabel
                value="false"
                control={<Radio color="primary" />}
                label="without Bill number"
                labelPlacement="end"
              /> */}
            </RadioGroup>
          </Grid>
          <Grid item xs={12}>
            {withBill === "true" ? (
              <WithBillPage
                customer_type={customer_type}
                resetCustomer={resetCustomer}
              />
            ) : (
              <WithOutBillPage
                naviagateToItemReturn={naviagateToItemReturn}
                customer_type={customer_type}
                resetCustomer={resetCustomer}
              />
            )}
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
